import StudentOverviewPageActionTypes from '../actions/student-overview-page-action-types';
import { pagingSettings } from '../../../utils/GridPagingUtils';

const initialState = {
  loading: false,
  student: null,
  hoursSummary: null,
  studentCancelToken: null,
  selectedTab: 0,
  hours: [],
  hoursLoading: false,
  skip: pagingSettings.paging.skip,
  take: pagingSettings.paging.take,
  total: 0,
  sorting: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case StudentOverviewPageActionTypes.LOAD_STUDENT_OVERVIEW_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case StudentOverviewPageActionTypes.LOAD_STUDENT_OVERVIEW_PAGE_END:
      return {
        ...state,
        loading: false,
        student: action.payload?.student,
        hoursSummary: action.payload?.hoursSummary
      };
    case StudentOverviewPageActionTypes.SELECT_STUDENT_OVERVIEW_PAGE_TAB:
      return {
        ...state,
        selectedTab: action.payload?.selected
      };
    case StudentOverviewPageActionTypes.LOAD_STUDENT_HOURS_START:
      return {
        ...state,
        hoursLoading: true
      };
    case StudentOverviewPageActionTypes.LOAD_STUDENT_HOURS_END:
      return {
        ...state,
        hoursLoading: false,
        hours: action.payload?.hours ?? [],
        total: action.payload?.total ?? 0,
        skip: action.payload?.skip ?? state.skip,
        take: action.payload?.take ?? state.take
      };
    case StudentOverviewPageActionTypes.SORT_STUDENT_HOURS:
      return {
        ...state,
        sorting: action.payload
      };
    default:
      return state;
  }
};
